import {useMutation} from '@tanstack/react-query'
import api from 'src/services/api'

type ExportDetectionsDTO = {
  fileType: 'pdf' | 'csv'
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
    status?: Array<string>
  }
  start: string
  end: string
}

export default function useDashboardEventsReport() {
  const mutation = useMutation({
    mutationFn: async (data: ExportDetectionsDTO) => {
      return await api.reports.getDashboardEventsExportFile(data)
    },
  })

  return mutation
}
